'use es6';

import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { editTaskLink } from '../../utils/links';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CREATE_URL = 'tasks/v1/tasks/from-recommendation';
const RecommendationProxyPage = () => {
  const history = useHistory();
  const {
    recommendationId: recommendationIdString
  } = useParams();
  const recommendationId = Number(recommendationIdString);
  useEffect(() => {
    http.post(CREATE_URL, {
      data: recommendationId
    }).then(response => {
      const taskId = response.objectId;
      const editTaskUrl = editTaskLink('/', taskId, false);
      history.push(editTaskUrl);
    }).catch(err => {
      Raven.captureException(err, {
        extra: {
          recommendationId
        }
      });
      history.push('/', {});
    });
  }, [history, recommendationId]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};
export default RecommendationProxyPage;